import {Directive, HostListener} from '@angular/core';
import {Location} from '@angular/common';

@Directive({
  selector: '[app-go-back]',
  standalone: true,
})
export class GoBackDirective {
  constructor(private readonly location: Location) {}

  @HostListener('click')
  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      /* let's try to close the tab */
      window.close();
    }
  }
}
